import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { CurrencyProvider } from "./contexts/currency/index.js";
import { NumberFormatProvider } from "./contexts/numberFormat/index.js";
import { ThemeProvider } from "./contexts/theme/index.js";
import "./styles.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <ThemeProvider>
        <NumberFormatProvider>
          <CurrencyProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CurrencyProvider>
        </NumberFormatProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
